import { render, staticRenderFns } from "./chengYuan.vue?vue&type=template&id=f4852e9e&scoped=true"
import script from "./chengYuan.vue?vue&type=script&lang=js"
export * from "./chengYuan.vue?vue&type=script&lang=js"
import style0 from "./chengYuan.vue?vue&type=style&index=0&id=f4852e9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4852e9e",
  null
  
)

export default component.exports